
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import subscriptions from "@/api/routes/subscriptions";

import ImageView from "@/components/ImageView.vue";
import AudioView from "@/components/audioView.vue";
import VideoView from "@/components/VideoView.vue";
import PdfView from "@/components/PdfView.vue";
import CFileDownload from "@/components/FileDownload.vue";

import SubscriptionUnit from "@/models/subscriptions/unit";
import PracticalVersion from "@/models/unit/unitable/practical/version";

@Component({
  name: "CSubscriptionUnitPractical",
  components: {
    ImageView,
    AudioView,
    VideoView,
    PdfView,
    CFileDownload
  }
})
export default class CSubscriptionUnitPractical extends Vue {
  @Prop({ required: true }) protected subscription_unit!: SubscriptionUnit;
  @Prop({ required: true }) private is_current_user_subscription!: boolean;

  public url: string | null = null;
  public url_file_type: string | null = null;
  public url_type: "image" | "video" | "audio" | "pdf" | null = null;

  public description: string = "";

  protected async created() {
    await this.changePractical();
  }

  @Watch("subscription_unit")
  private async changePractical() {
    const practical = this.subscription_unit.unit_version
      .unitable as PracticalVersion;

    this.description = practical.description;

    this.url = practical.url ? practical.url : null;
    this.url_file_type = practical.file_type ? practical.file_type : null;

    if (practical.isImage()) {
      this.url_type = "image";
    } else if (practical.isVideo()) {
      this.url_type = "video";
    } else if (practical.isAudio()) {
      this.url_type = "audio";
    } else if (practical.isPdf()) {
      this.url_type = "pdf";
    } else {
      this.url_type = null;
    }

    await this.calculate();
  }

  private async calculate() {
    if (!this.is_current_user_subscription) {
      return;
    }

    return this.$api
      .get(subscriptions.calculate_unit(this.subscription_unit.id))
      .then(() => {
        this.$emit("end", true);
      })
      .catch(({ response: res }) => {
        this.$notify({
          group: "notifications",
          type: "error",
          text: res.data.error,
          speed: 500
        });
      });
  }
}
